<template>
  <div class="producttypegory" >
    <el-divider content-position="left">单品产品类型列表</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.type_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入分类名称"
        size="mini"
        clearable
        :remote-method="searchRemoteCftype"
        :loading="searchLoading"
        @change="handleSearchCftype"
      >
        <el-option
          v-for="searchCompany in searchCategories"
          :key="searchCompany.id"
          :label="searchCompany.type_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="typeIn"
          >添加</el-button
        >
         <el-button type="primary" size="mini" @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
    </div>
    <el-drawer
      title="添加"
      :visible.sync="typeIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="typeForm"
          :rules="rules"
          ref="typeForm"
          label-width="100px"
        >
          <el-form-item label="分类名称" prop="type_name">
            <el-input v-model="typeForm.type_name" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="status">
            是
            <el-switch
              v-model="typeForm.status"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('typeForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="typeEditDrawer"
      :direction="direction"
      :before-close="handleCloseEtid"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="edittypeForm"
          :rules="rules"
          ref="edittypeForm"
          label-width="100px"
        >
          <el-form-item label="分类名称" prop="type_name">
            <el-input
              v-model="edittypeForm.type_name"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="stauts">
            是
            <el-switch
              v-model="ifDisplay"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('edittypeForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-table
    height="calc(100vh - 280px)"
      :data="typeData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="id" label="ID"> </el-table-column>
      <el-table-column prop="type_name" label="分类名称"> </el-table-column>
      <el-table-column prop="status" label="是否显示">
        <template slot-scope="scope">
          是
          <el-switch
            v-model="ListIfDisplay[scope.row.id]"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @click.native="editListRadio(scope.row)"
          >
          </el-switch>
          否
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, typeData)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-refresh-left"
              circle
              @click.native.prevent="delRow(scope.$index, typeData)"
              >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-footer">
      <el-pagination
      class="pagination-style"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="typePerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MroductTypegory',
  data () {
    var typeId = (rule, value, callback) => {
      if (value.length > 100) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请输入分类名称！'))
      }
      callback()
    }
    return {

      searchArr: {
        type_id: ''
      },
      npage: 1,
      typePerPage: 30,
      total: null,
      listSortForm: [],
      typeData: [],
      searcher: null,
      typeEditDrawer: false,
      searchLoading: false,
      searchCategories: [],
      typeIndrawer: false,
      direction: 'rtl',
      ifDisplay: 2,
      ListIfDisplay: [],
      listSort: [],
      type: '',
      typeForm: {
        typeId: '',
        type_name: '',
        status: false
      },
      edittypeForm: {
        typeId: '',
        type_name: '',
        status: false
      },
      rules: {
        typeId: [
          {
            validator: typeId,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.loadTable()
  },
  // watch: {
  //   searcher: function (n, o) {
  //     this.loadTable(n)
  //   }
  // },
  methods: {
    loadTable () {
      this.$axios
        .get('api/product_type', {
          params: {
            page: this.npage,
            perpage: this.typePerPage,
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.typeData = data.data.data
            this.total = data.data.total
            this.loadRadio()
            this.loadSort()
          }
        })
        .catch()
    },
    loadRadio () {
      this.typeData.map(item => {
        if (item.status === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadSort () {
      this.typeData.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.typePerPage = val
      this.loadTable()
    },
    editRow (index, data) {
      this.$axios
        .get('api/product_type/show', {
          params: {
            id: data[index].id
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            if (data.data.status === 1) {
              this.ifDisplay = false
            } else {
              this.ifDisplay = true
            }
            this.edittypeForm.type_name = data.data.type_name
            this.type = data.data.id
          }
        })
        .catch()
      this.typeEditDrawer = true
    },
    delRow (index, data) {
      if (confirm('确定要删除吗') === true) {
        this.$axios
          .get('api/product_type/delRow', {
            params: {
              id: data[index].id
            }
          })
          .then(({ data }) => {
            if (data.code === 1) {
              this.$message.success(data.msg)
              this.loadTable()
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      }
    },
    searchRemoteCftype (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/product_type/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    handleSearchCftype (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    typeIn () {
      this.typeIndrawer = true
    },
    handleClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.resetForm('typeForm')
          this.typeEditDrawer = false
          done()
        })
        .catch(_ => {})
    },
    handleCloseEtid (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.resetForm('edittypeForm')
          done()
        })
        .catch(_ => {})
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/product_type/add', {
              type_name: this.typeForm.type_name,
              status: this.typeForm.status === false ? 1 : 2
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.resetForm('typeForm')
                this.typeIndrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSubmitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .put('api/product_type/edit', {
              id: this.type,
              type_name: this.edittypeForm.type_name,
              status: this.ifDisplay === false ? 1 : 2
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.typeEditDrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editListRadio (row) {
      this.$axios
        .put('api/product_type/listshow', {
          id: row.id,
          status: this.ListIfDisplay[row.id] === false ? 1 : 2
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    setSort (row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .put('api/product_type/setsort', {
          id: row.id,
          sort: this.listSort[row.id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    }
  }
}
</script>

<style  scoped>
.producttypegory {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 15px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/service_manage/ProductTypegory.vue